module.exports = __webpack_public_path__ + "static/media/water.ebd684a3.jpg";